<mat-toolbar class="header">
  <div class="logo-container">
    <a target="_self" [routerLink]="['/']">
      <svg width="137" height="32" viewBox="0 0 137 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M136.064 2.232H117.835L119.9 0H136.064V2.232ZM125.616 5.35259L123.226 3.14001H104.929V5.35259H125.616ZM132.489 11.7241L130.146 9.55499H104.929V11.7241H132.489ZM66.3833 31.1371H63.7742V24.8789C63.7742 24.1348 63.7548 23.4468 63.4405 22.9966C63.1273 22.5657 62.6176 22.3691 61.989 22.3691C60.4005 22.3691 59.5959 23.408 59.5959 24.9977V31.1371H57.0073V15.68H59.5959V22.3897H59.6348C60.1068 21.408 61.2039 20.4663 62.9113 20.4663C65.245 20.4663 66.3833 21.6034 66.3833 24.1348V31.1371ZM86.4116 31.1424H96.1602V28.907H89.095V24.811H95.487V22.619H89.095V18.331H95.9442V16.155H86.4116V31.1424ZM84.3462 31.154H81.3885L78.4685 25.1597H75.7656V31.154H73.0811V16.1666H78.7828C79.8011 16.1666 80.8399 16.3437 81.7405 16.7746C83.0742 17.4203 84.0331 18.5757 84.0331 20.4763C84.0331 23.0637 82.4068 24.1609 81.0159 24.61L84.3462 31.154ZM75.7656 18.0616V22.9804H78.4685C80.0171 22.9804 81.2696 22.3713 81.2696 20.4718C81.2696 18.6501 79.9188 18.0616 78.5268 18.0616H75.7656ZM55.1048 24.1719C54.9871 21.6222 53.0648 20.445 50.5345 20.445C47.3962 20.445 45.4751 22.6416 45.4751 25.9364C45.4751 29.3102 47.2797 31.389 50.4957 31.389C53.0648 31.389 55.0077 30.0553 55.1631 27.4667H52.6534C52.6145 28.3879 52.1242 29.5844 50.5151 29.5844C48.6317 29.5844 48.1425 27.8587 48.1425 25.8782C48.1425 23.8382 48.8282 22.1913 50.5345 22.1913C51.8488 22.1913 52.4568 23.093 52.5551 24.1719H55.1048ZM43.7683 31.1404H41.1592V20.705H42.5855H43.7683V31.1404ZM41.1401 18.6438H43.787V16.23H42.4898H41.1401V18.6438ZM38.7676 31.1408H36.1585V24.8825C36.1585 24.1385 36.139 23.4505 35.8247 23.0003C35.5116 22.5694 35.0007 22.3728 34.3733 22.3728C32.7847 22.3728 31.9802 23.4117 31.9802 25.0014V31.1408H29.3916V20.7054H31.8819V22.4505H31.9207C32.451 21.3923 33.5687 20.47 35.2956 20.47C37.6293 20.47 38.7676 21.6071 38.7676 24.1385V31.1408ZM20.1721 20.705H17.5835V27.8056C17.5835 30.257 18.7606 31.3747 21.0944 31.3747C22.7812 31.3747 23.8406 30.4524 24.3504 29.4136H24.3892V31.1404H26.9001V20.705H24.2909V26.393C24.2909 28.3942 23.5275 29.473 21.9584 29.473C21.3104 29.473 20.8189 29.2764 20.5252 28.8262C20.2121 28.3942 20.1721 27.6867 20.1721 26.9416V20.705ZM15.1589 15.75V31.1397H12.4834V18.494H12.4251C12.4251 18.494 12.0114 19.8311 11.9291 20.078L8.68571 29.5169H6.25371L3.13486 20.4883C3.13029 20.4826 2.52686 18.5134 2.52686 18.5134H2.46857V31.1397H0V15.75H4.08571L5.05714 18.5111L6.91086 23.7797C7.34743 25.0677 7.56686 25.8917 7.56686 25.8917H7.62514C7.62514 25.8917 7.824 25.0871 8.26629 23.7774L10.1006 18.526L11.0869 15.75H15.1589ZM104.929 28.9V31.1332H121.092L123.168 28.9H104.929ZM104.929 18.2997V16.15H134.9L132.906 18.2997H104.929ZM104.929 24.8109V22.62H128.944L126.915 24.8109H104.929ZM136.063 25.775V27.9876H117.716L115.327 25.775H136.063ZM136.063 6.32501H114.082L112.047 8.51587H136.063V6.32501ZM136.063 19.4V21.5692H110.808L108.462 19.4H136.063ZM108.094 12.835L106.108 14.9836H136.063V12.835H108.094Z"
          fill="white"
        ></path>
      </svg>
    </a>
  </div>

  <div class="header-spacer">
    <div [ngClass]="['app-info', appEnv]">
      <h4 class="app-name">{{ appName }}</h4>
      @if (showEnvironment) {
        <p [ngClass]="['app-env-info', compileMode]">{{ appEnv }}</p>
      }
    </div>
  </div>

  <div class="user-profile-bar">
    <div class="user-profile-wrapper" [matMenuTriggerFor]="userMenu">
      @if (user$ | async; as user) {
        <div class="user-details">
          <div class="user-name">{{ user.name }}</div>
          <div class="user-email">{{ user.username }}</div>
        </div>

        <div class="user-picture">
          @if (user.picture) {
            <img [src]="user.picture" alt="User picture" />
          } @else {
            <mat-icon>account_circle</mat-icon>
          }
        </div>
      }
    </div>

    <mat-menu #userMenu="matMenu" xPosition="after" yPosition="below">
      <button mat-menu-item (click)="logoutUser()">Logout</button>
    </mat-menu>
  </div>

  <div class="header-icon build-info">
    <mat-icon matTooltip="{{ getBuildTooltipText() }}" matTooltipPosition="below" matTooltipClass="multiline-tooltip"
      >info</mat-icon
    >
  </div>

  <div class="header-icon help">
    <a href="{{ getMailToLink() }}">
      <mat-icon>help_outline</mat-icon>
    </a>
  </div>
</mat-toolbar>

<!-- banner -->
@if (app && app.banner) {
  <div class="banner">
    @if (app.banner.title) {
      <h5>{{ app.banner.title }}</h5>
    }
    @if (app.banner.content) {
      <p>{{ app.banner.content }}</p>
    }
  </div>
}
